/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTableFooter from './AdvanceTableFooter';
import AdvanceTablePagination from './AdvanceTablePagination';
import AdvanceTableSearchBox from './AdvanceTableSearchBox';

const CustomAdvanceTable = props => {
  const {
    columns = [],
    data = [],
    title = 'Selection Example',
    addButtonLabel = 'New',
    addButtonIcon = 'plus',
    showSearchInput = false,
    searchInputPlaceHolder = 'Search by name',
    onClickAddNew = () => {},
    addNew = true,
    content = null,
    rowsPerPageSelection = false,
    viewAllBtn = true,
    perPage = 5,
    showTablePagination = false
  } = props;

  function BulAction({ selectedRowIds, globalFilter, setGlobalFilter }) {
    const objectLength = Object.keys(selectedRowIds).length;
    return (
      <Row className="flex-between-center mb-3">
        <Col
          sm="auto"
          className="d-md-flex align-items-center justify-content-md-start pe-md-0"
        >
          <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
            {objectLength > 0
              ? 'You have selected ' +
                objectLength +
                ` row${objectLength > 1 ? 's' : ''}`
              : title}
          </h5>

          {showSearchInput && (
            <div className="ms-md-4 mt-2 mt-md-0">
              <AdvanceTableSearchBox
                className="table-input-search-width"
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                placeholder={searchInputPlaceHolder}
                showSearchIcon={false}
              />
            </div>
          )}
        </Col>
        <Col sm="auto" className="text-md-end ps-md-0 mt-3 mt-md-0">
          {Object.keys(selectedRowIds).length > 0 ? (
            <div className="d-flex">
              <Form.Select size="sm" aria-label="Bulk actions">
                <option>Bulk Actions</option>
                <option value="refund">Refund</option>
                <option value="delete">Delete</option>
                <option value="archive">Archive</option>
              </Form.Select>
              <Button
                type="button"
                variant="falcon-default"
                size="sm"
                className="ms-2"
              >
                Apply
              </Button>
            </div>
          ) : (
            <div id="orders-actions">
              {content}
              {addNew && (
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon={addButtonIcon}
                  iconClassName="text-primary"
                  transform="shrink-3"
                  onClick={onClickAddNew}
                  className="me-2"
                >
                  <span className="text-primary d-none d-lg-inline-block ms-2">
                    {addButtonLabel}
                  </span>
                </IconButton>
              )}
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="filter"
                transform="shrink-3"
                className="me-2"
              >
                <span className="d-none d-lg-inline-block ms-2">Filter</span>
              </IconButton>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="external-link-alt"
                transform="shrink-3"
              >
                <span className="d-none d-lg-inline-block ms-2">Export</span>
              </IconButton>
            </div>
          )}
        </Col>
      </Row>
    );
  }

  return (
    <Card>
      <Card.Body>
        <AdvanceTableWrapper
          columns={columns}
          data={data}
          sortable
          pagination
          perPage={perPage}
          selection
          selectionColumnWidth={30}
        >
          <BulAction table />
          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              striped: true,
              className: 'fs--1 mb-0 overflow-hidden'
            }}
          />
          <div className="mt-3">
            {showTablePagination ? (
              <AdvanceTablePagination table />
            ) : (
              <AdvanceTableFooter
                rowCount={data.length}
                table
                rowInfo
                navButtons
                rowsPerPageSelection={rowsPerPageSelection}
                viewAllBtn={viewAllBtn}
                perPage={perPage}
              />
            )}
          </div>
        </AdvanceTableWrapper>
      </Card.Body>
    </Card>
  );
};

CustomAdvanceTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.string,
  addButtonLabel: PropTypes.string,
  addButtonIcon: PropTypes.string,
  searchInputPlaceHolder: PropTypes.string,
  showSearchInput: PropTypes.bool,
  onClickAddNew: PropTypes.func,
  addNew: PropTypes.bool,
  content: PropTypes.node,
  rowsPerPageSelection: PropTypes.bool,
  viewAllBtn: PropTypes.bool,
  showTablePagination: PropTypes.bool,
  perPage: PropTypes.number
};

export default CustomAdvanceTable;
